module.exports = __webpack_public_path__ + "static/media/Mitsubachi-1.a799bce9.jpg";